/// <reference path="../../../ui/types.d.ts" />
import Editor from '@monaco-editor/react';

const MonacoEditorWidget = (props: any) => {
    const { id, label, value, onChange, theme } = props;
    const { language, minimap = false, lineNumbers = 'off', height = 250, options } = props.schema;
    const paletteMode = theme.palette.mode;

    const handleEditorChange = (newValue: any) => {
        onChange(newValue);
    };

    return (
        <div>
            {label && <crowdin-h5 htmlFor={id}>{label || 'Provide your code'}</crowdin-h5>}
            <Editor
                height={height}
                language={language || 'javascript'}
                defaultValue={''}
                value={value}
                onChange={handleEditorChange}
                options={{
                    theme: paletteMode === 'light' ? 'vs-light' : 'vs-dark',
                    lineNumbers: lineNumbers,
                    minimap: {
                        enabled: minimap,
                    },
                    ...options,
                }}
            />
        </div>
    );
};

export default MonacoEditorWidget;
